import { render, staticRenderFns } from "./JobAssistant.vue?vue&type=template&id=54d93aae"
import script from "./JobAssistant.vue?vue&type=script&lang=js"
export * from "./JobAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports